/**
 * App Icon
 *
 * Maps stored app icon keys to safe Lucide icons.
 *
 * Primary responsibilities:
 * - Avoid arbitrary icon rendering
 * - Keep app headers and cards visually consistent
 *
 * Dependencies:
 * - lucide-react
 * - marshmallow-icons
 */

import {
  Bug,
  FileText,
  Globe2,
  ListChecks,
  Megaphone,
  Radar,
  Repeat2,
  Search,
  Send,
  UserCheck
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { LosiMain } from 'marshmallow-icons'

import { cn } from '@/lib/utils'

const iconMap: Record<string, LucideIcon> = {
  bug: Bug,
  'file-text': FileText,
  globe: Globe2,
  'list-checks': ListChecks,
  megaphone: Megaphone,
  radar: Radar,
  repeat: Repeat2,
  search: Search,
  send: Send,
  'user-check': UserCheck
}

interface AppIconProps {
  className?: string
  icon?: string | null
}

// --------------

export function AppIcon({ className, icon }: AppIconProps) {
  if (!icon || icon === 'losi' || icon === 'sparkles') {
    return (
      <LosiMain aria-hidden="true" className={cn('size-5', className)} color="currentColor" />
    )
  }

  const Icon = iconMap[icon] ?? Globe2

  return <Icon className={cn('size-5', className)} strokeWidth={1.8} />
}
